import { Button } from '@/components/ui/button';
import { SCHEDULE_DEMO_URL } from '@/constants/externalLinks';

export default function IntroSection() {
  return (
    <section className="py-12 bg-highlight text-black">
      <div className="landing-container flex flex-col items-center justify-center">
        <div className="max-w-[778px] flex flex-col items-center justify-center">
          <h2 className="text-4xl font-['Times_New_Roman'] font-bold leading-[1.2] tracking-normal text-center max-w-[450px] mb-4">
            Cultura em tempo real. Pronta para virar resultado.
          </h2>
          <p className="font-sans font-normal text-sm leading-[22.08px] tracking-normal text-center mb-9">
            Transformamos dados culturais em decisões estratégicas todos os dias. Monitoramos tendências, comportamentos e criadores em alta para entregar insights acionáveis — prontos para virar conteúdo, mídia ou campanhas de influência.
          </p>
          <Button asChild className="bg-black text-white hover:bg-gray-800 rounded-lg">
            <a
              href={SCHEDULE_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-tracking-id="landing-schedule-demo-intro"
            >
              Agende uma apresentação
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}

